import { apiFetch } from "../../services/api";

export function formatApiErrorDetail(data, fallback = "Request failed") {
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => {
        if (typeof d === "string") return d;
        if (d && typeof d === "object") {
          return d.msg || d.message || null;
        }
        return null;
      })
      .filter(Boolean);
    if (parts.length) return parts.join("; ");
  }
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.detail === "string") return detail.detail;
  }
  if (typeof data?.message === "string") return data.message;
  return fallback;
}

export async function apiJsonOrThrow(url, options = {}) {
  const response = await apiFetch(url, options);
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(
      formatApiErrorDetail(data, `HTTP error! status: ${response.status}`)
    );
  }
  return data;
}

export function setTransientMessage(setter, message, timeoutMs = 2000) {
  setter(message);
  setTimeout(() => setter(null), timeoutMs);
}
